import { PcApiResponse } from '@/api/pc-api/types';
import { api } from '@/utils/api';

export type MyInfo = {
  email: string;
  id: string;
  name: string;
  phoneNumber: string;
};

export const getMyInfo = () => {
  return api<PcApiResponse<MyInfo>>('get', `/pc-api/v1/user/my`);
};
